import { put, select, takeLatest } from 'redux-saga/effects'

import ActionsTypes from '../../constants/ActionsTypes'

import { globalLoadingActionCreators, errorManagerActionCreators, companiesManagerActionCreators, toastSuccessActionCreators } from '../actions'

import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'
import { uriList } from '../../routings/settings/RouteList'

const getCompanies = function* ({ payload }) {
	try {
		const queryParam = payload.queryParams
		const user = yield select(selectIdsUser)
		const apiCall = R.GET_COMPANIES(queryParam)
		const bodyMsg = payload.filters
		yield put(globalLoadingActionCreators.startLoading())

		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMsg)
		yield put(companiesManagerActionCreators.getCompaniesSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(companiesManagerActionCreators.getCompaniesFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const setStateCompany = function* ({ payload }) {
	try {
		const queryParams = { action: payload.mode === 'enable' ? 'toEnable' : 'toDisable' }
		const user = yield select(selectIdsUser)
		const apiCall = R.SET_STATE_COMPANY(payload.id, queryParams)

		yield put(globalLoadingActionCreators.startLoading())

		const data = yield API_TOKEN(user.jwt).put(apiCall)
		yield put(companiesManagerActionCreators.setStateCompanySuccess(payload.id, data.data))

		yield put(
			toastSuccessActionCreators.hydrateToast(
				payload.mode === 'enable' ? 'toast__companiesManagement__companyEnabled' : 'toast__companiesManagement__companyDisabled'
			)
		)
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(companiesManagerActionCreators.setStateCompanyFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getAvailableListsCompany = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_COMPANY_AVAILABLE_LISTS()
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, {})

		yield put(companiesManagerActionCreators.getAvailableListsCompanySuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(companiesManagerActionCreators.getAvailableListsCompanyFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const createCompany = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.CREATE_COMPANY()

	const redirectRequest = !payload.noRedirect ? `${uriList.companies}${uriList.companiesManager}` : ''

	yield put(globalLoadingActionCreators.startLoading())
	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, payload.data)

		yield put(companiesManagerActionCreators.createCompanySuccess(data.data))

		yield put(toastSuccessActionCreators.hydrateToast('toast__companiesManagement__detail__companyCreate', redirectRequest))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(companiesManagerActionCreators.createCompanyFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getDataForUpdate = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_COMPANY_DATA(payload.id)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall, {})

		yield put(companiesManagerActionCreators.getDataForUpdateSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(companiesManagerActionCreators.getDataForUpdateFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const updateCompany = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const idItem = payload.id
	const apiCall = R.UPDATE_COMPANY(idItem)

	const redirectRequest = `${uriList.companies}${uriList.companiesManager}`

	yield put(globalLoadingActionCreators.startLoading())
	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, payload.data)

		yield put(companiesManagerActionCreators.updateCompanySuccess(data.data))

		yield put(toastSuccessActionCreators.hydrateToast('toast__companiesManagement__detail__companyModify', redirectRequest))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(companiesManagerActionCreators.updateCompanyFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const checkDistributionGroupDisabling = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const idItem = payload.idCompanyTyped
	const idCompany = payload.idCompany
	const isDistributorGroup = payload.isDistributorGroup
	const apiCall = R.CHECK_DISTRIBUTION_DISABLING(idCompany, idItem, isDistributorGroup)

	yield put(globalLoadingActionCreators.startLoading())
	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(companiesManagerActionCreators.checkDisablingGroupDistributionSuccess(idItem, true))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(companiesManagerActionCreators.checkDisablingGroupDistributionFailure(idItem, false))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const deleteTechSupport = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const idItem = payload.idCompanyTyped
	const idCompany = payload.idCompany
	const isDistributorGroup = payload.isDistributorGroup
	const apiCall = R.DELETE_TECH_SUPPORT(idCompany, idItem)

	yield put(globalLoadingActionCreators.startLoading())
	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(companiesManagerActionCreators.deleteTechSupportSuccess(idItem, true))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(companiesManagerActionCreators.deleteTechSupportFailure(idItem, false))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const checkDistributionDisabling = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const idItem = payload.idCompanyTyped
	const idCompany = payload.idCompany
	const isDistributorGroup = payload.isDistributorGroup
	const apiCall = R.CHECK_DISTRIBUTION_DISABLING(idCompany, idItem, isDistributorGroup)

	yield put(globalLoadingActionCreators.startLoading())
	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(companiesManagerActionCreators.checkDisablingDistributionSuccess(idItem, true))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(companiesManagerActionCreators.checkDisablingDistributionFailure(idItem, false))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const putSMSRefill = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const idCompany = payload.id
	const apiCall = R.PUT_SMS_REFILL(idCompany, payload.value)

	yield put(globalLoadingActionCreators.startLoading())
	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(companiesManagerActionCreators.putSMSRefillSuccess(data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(companiesManagerActionCreators.putSMSRefillFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const putDeleteCompanySubGroupPartnership = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.PUT_DELETE_COMPANY_SUBGROUP_PARTNERSHIP(payload.idCompany, payload.idCompanySubgroupPartner)

	yield put(globalLoadingActionCreators.startLoading())
	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(companiesManagerActionCreators.putDeleteCompanySubGroupPartnershipSuccess(data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(companiesManagerActionCreators.putDeleteCompanySubGroupPartnershipFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const putDeleteCompanySubGroupLink = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.PUT_DELETE_COMPANY_SUBGROUP_LINK(payload.idCompany, payload.idCompanySubgroupLink)

	yield put(globalLoadingActionCreators.startLoading())
	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(companiesManagerActionCreators.putDeleteCompanySubGroupLinkSuccess(data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(companiesManagerActionCreators.putDeleteCompanySubGroupLinkFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_COMPANIES, getCompanies)
	yield takeLatest(ActionsTypes.SET_STATE_COMPANY, setStateCompany)
	yield takeLatest(ActionsTypes.GET_COMPANY_AVAILABLE_LISTS, getAvailableListsCompany)
	yield takeLatest(ActionsTypes.CREATE_COMPANY, createCompany)
	yield takeLatest(ActionsTypes.GET_COMPANY_DATA, getDataForUpdate)
	yield takeLatest(ActionsTypes.UPDATE_COMPANY, updateCompany)
	yield takeLatest(ActionsTypes.CHECK_DISTRIBUTION_GROUP_DISABLING, checkDistributionGroupDisabling)
	yield takeLatest(ActionsTypes.CHECK_DISTRIBUTION_DISABLING, checkDistributionDisabling)
	yield takeLatest(ActionsTypes.DELETE_TECH_SUPPORT, deleteTechSupport)
	yield takeLatest(ActionsTypes.PUT_SMS_REFILL, putSMSRefill)
	yield takeLatest(ActionsTypes.PUT_DELETE_COMPANY_SUBGROUP_PARTNERSHIP, putDeleteCompanySubGroupPartnership)
	yield takeLatest(ActionsTypes.PUT_DELETE_COMPANY_SUBGROUP_LINK, putDeleteCompanySubGroupLink)
}

export default sagas
